import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import { AdminModule, AdminModuleListEntry, AdminModulesSortPayload } from 'types/admin/modulesV2';

export class ModuleListV2Service {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getModuleList = async () => {
    const response = await this.axiosInstance.get<Result<AdminModuleListEntry[]>>('/api/admin/v2/learning-hub/modules');
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
  };

  getModule = async (id: string) => {
    const response = await this.axiosInstance.get<Result<AdminModule>>(`/api/admin/v2/learning-hub/modules/${id}`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
  };

  createModule = async (module: AdminModule) => {
    const response = await this.axiosInstance.post('/api/admin/v2/learning-hub/modules', module);

    if (response.status === 200) {
      return response.data.data as string;
    }
    throw Error('There was an internal error while creating new module.');
  };

  updateModule = async (module: AdminModule) => {
    const response = await this.axiosInstance.put('/api/admin/v2/learning-hub/modules', module);

    if (response.status === 200) {
      return null;
    }
    throw Error('There was an internal error while updating a module.');
  };

  sendToTranslation = async (moduleId: string) => {
    await this.axiosInstance.post(`/api/admin/v2/learning-hub/modules/${moduleId}/send-to-translation`);
  };

  resyncTranslation = async (moduleId: string, language: string) => {
    await this.axiosInstance.post(`/api/admin/v2/learning-hub/modules/${moduleId}/resync-translation/${language}`);
  };

  deleteModule = async (moduleId: string) => {
    await this.axiosInstance.delete(`/api/admin/v2/learning-hub/modules/${moduleId}`);
  };

  sortModules = async (payload: AdminModulesSortPayload) => {
    const response = await this.axiosInstance.post<Result<boolean>>('/api/admin/v2/learning-hub/modules/sort', payload);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while sorting modules.');
  };
}
